import React, { useContext } from "react";
import ReactSelector from "./CommonReactSelector";
import AppContext from "../../context/AppContext";

export default function FilterSelect({
  options = [],
  defaultText,
  onChange,
  value,
  pageType,
  classname,
  listBoxClass,
  ...rest
}) {
  const { theme } = useContext(AppContext);

  // Map option array to react-select format: { label, value }
  const mappedOptions = (options || []).map((option) => ({
    label: pageType === "report" ? (option.label || option.value) : (option.value || option.label),
    value: option.value,
    id: option.id,
  }));

  // Find the selected option in our mapped array
  const selectedOption = mappedOptions.find((opt) => opt.value === value) || null;

  const handleSelectChange = (selected) => {
    // Call the original onChange with the value string, which is what the parent components expect
    onChange?.(selected ? selected.value : "");
  };

  return (
    <div className={`${listBoxClass || ""} relative mt-1 min-w-[200px]`} {...rest}>
      <ReactSelector
        options={mappedOptions}
        placeholder={defaultText}
        value={selectedOption}
        onChange={handleSelectChange}
        height="36px"
        borderRadius="6px"
      />
    </div>
  );
}
